export { RoomRateConfigurationWizardV2Connected as RoomRateConfigurationWizardV2 } from './containerV2';
